import { Component, OnInit,ViewChild, ViewEncapsulation,Input,Injectable } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import {NgbDate, NgbCalendar,NgbDatepicker, NgbDatepickerI18n,NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

export interface Periodos {
  id_periodoEnvio: number;
  fechaInicio_periodoEnvio: string;
  fechaTermino_periodoEnvio: string
}



export interface calendario{
  mes:number;
  starAt:Date;
  minDate:Date;
  maxDate:Date;
  range;
  model: NgbDateStruct;
}

@Component({
  selector: 'app-modal-calendario',
  templateUrl: './modal-calendario.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./modal-calendario.component.scss']
})
export class ModalCalendarioComponent implements OnInit {
  @ViewChild(NgbDatepicker, {static: true}) datepicker: NgbDatepicker;
 

  minDate;
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate;
  toDate: NgbDate | null = null;

  //@Input() listaPeriodo: any[]=[];
  @Input() ano:string;

  listaInicio: any[]=[];
  listaFin: any[]=[];
  listaPeriodosEnvio: any[]=[];
  listameses: any[]=[];
  listAno: any[]=[];
  final: NgbDate | null = null;

  listaPeriodo: Periodos[]=[];

  constructor(calendar: NgbCalendar,
    public i18n: NgbDatepickerI18n,
    private dataService: DataService,) 
  { 

    /*this.minDate={year:calendar.getToday().year,month:1,day:1};
    this.fromDate = calendar.getToday();
    this.final = calendar.getNext(calendar.getToday(), "d", 2);*/
    
  }

  ngOnInit() {
     this.dataService.getListPeriodosEnvio().subscribe(
      async (data) => {
        this.listaPeriodo = data['data'];
      },
      error => {
        console.error(error);       
      }
    );
  }

}
